
function Loading() {
    return (
    <div className='center'>
        <img className='vinyl-loader' src="images/loading.png" />
    </div>
    )
}

export default Loading